import { lazy } from 'react'

export default {
    path: '/clienti',
    title: 'Clienti',
    authenticated: true,
    component: lazy(() => import('./filter')),
    pages: [
        {
            path: '/:clienteId',
            title: 'Cliente: {{params.clienteId}}',
            drawer: false,
            component: lazy(() => import('./detail'))
        }
    ]
}